// Fixed-size promise card (TVK guide palette) captured to PNG for sharing
const C = { bg: "#f6f7f4", ink: "#15302b", muted: "#56665f", line: "#d9e0dc", accent: "#e0911a", accentInk: "#5a3600", accentSoft: "#fdf0d9", deep: "#1f4a41", deepSoft: "#e3eeea", chip: "#eef2f0" };

export default function SharePromiseCard({ typeLabel, isBenefit, title, amount, desc, who, pillar, pageText, url, t, lang }) {
  const ta = lang === "ta";
  const font = "'Mukta', 'Noto Sans Tamil', sans-serif";
  const display = "'Baloo Thambi 2', 'Mukta', 'Noto Sans Tamil', sans-serif";
  return (
    <div style={{ width: 540, background: C.bg, color: C.ink, fontFamily: font }} data-testid="share-promise-card">
      <div style={{ background: C.deep, color: "#fff", padding: "14px 24px", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <div style={{ fontFamily: "'Fraunces', serif", fontSize: 21, fontWeight: 700 }}>NeeYosi <span style={{ fontFamily: "'Noto Sans Tamil', sans-serif", fontSize: 15, opacity: 0.8 }}>நீ யோசி</span></div>
        <div style={{ fontSize: 12, fontWeight: 700, color: "#ffd89a", letterSpacing: ta ? 0 : "0.06em" }}>{t("nav_schemes")} 2026</div>
      </div>
      <div style={{ padding: "20px 24px 0", borderTop: `4px solid ${C.accent}` }}>
        <span style={{ fontSize: 12.5, fontWeight: 700, padding: "3px 10px", borderRadius: 99, background: isBenefit ? C.deepSoft : C.chip, color: isBenefit ? C.deep : C.muted }}>{typeLabel}</span>
        <div style={{ marginTop: 10, fontSize: 24, fontWeight: 800, lineHeight: 1.2, fontFamily: display }}>{title}</div>
        {amount && <div style={{ marginTop: 10, display: "inline-block", fontSize: 18, fontWeight: 700, color: C.accentInk, background: C.accentSoft, borderRadius: 10, padding: "4px 12px" }}>{amount}</div>}
        <p style={{ marginTop: 12, fontSize: 15.5, lineHeight: 1.55 }}>{desc}</p>
        <div style={{ marginTop: 10, fontSize: 13.5, color: C.muted, lineHeight: 1.5 }}>
          {who && <div><b>{t("for_label")}</b> {who}</div>}
          <div>{pillar} · {pageText}</div>
        </div>
        <div style={{ marginTop: 18, padding: "12px 0 16px", borderTop: `1px solid ${C.line}` }}>
          <div style={{ fontSize: 13, fontWeight: 700, color: C.deep, wordBreak: "break-all" }}>{url.replace(/^https?:\/\//, "")}</div>
          <div style={{ fontSize: 10.5, color: C.muted, marginTop: 4, lineHeight: 1.4 }}>{t("schemes_disclaimer")}</div>
        </div>
      </div>
    </div>
  );
}
